import Vue from 'vue'
import App from './App'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import appConfig from '@src/app.config'

require('bootstrap');
require('./custom');
require('../../website/resources/js/custom');


// ***********************
// Plugins Start
// ***********************
require('vue2-animate/dist/vue2-animate.min.css');

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import { Icon } from '@iconify/vue2';
Vue.component("Icon", Icon);

import axios from 'axios'
import qs from 'qs'
axios.defaults.withCredentials = true
axios.defaults.baseURL = appConfig.app_url;
axios.defaults.paramsSerializer = function(params) { return qs.stringify(params) };
Vue.prototype.$http = axios;

import CkRichEditor from '@views/global/CkRichEditor';
Vue.component("CkRichEditor", CkRichEditor);

import PrismEditorMain from '@views/global/PrismEditorMain';
Vue.component("PrismEditorMain", PrismEditorMain);

import moment from 'moment';
Vue.prototype.moment = moment;

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar);

import tdsort from '@views/global/tdsort';
Vue.component("tdsort", tdsort);

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
Vue.component("DateRangePicker", DateRangePicker);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import Avatar from 'vue-avatar';
Vue.component('avatar', Avatar);

import PrettyCheckbox from 'pretty-checkbox-vue';
require('pretty-checkbox/src/pretty-checkbox.scss');
Vue.use(PrettyCheckbox);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
import "vue-multiselect/dist/vue-multiselect.min.css";

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import VueTippy, { TippyComponent } from "vue-tippy";
import "tippy.js/themes/light.css";
Vue.use(VueTippy, {theme: "light", a11y: false, maxWidth: 500, placement: 'right'});
Vue.component("tippy", TippyComponent);

import vueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css'
Vue.component('vue-slider', vueSlider);

import Noty from 'noty';
window.Noty = Noty;
import VueNoty from 'vuejs-noty';
import 'vuejs-noty/dist/vuejs-noty.css'
Vue.use(VueNoty,{timeout:6000,progressBar:true,theme:'nest',layout:'topRight'});

import draggable from 'vuedraggable';
Vue.component('draggable', draggable);

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';



const files = require.context('../../website/resources/js/components/widgets/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
const widgets = []; var keys = files.keys(); for(var i in keys) { widgets.push(keys[i].split('/').pop().split('.')[0]); }
// ***********************
// Plugins End
// ***********************


// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

// SET MIXINS
Vue.mixin({
  watch: {
    '$store.state.auth.currentUser': { handler: function(n, o) {
      console.log('watch: currentUser');
      this.user = this.$store ? this.$store.state.auth.currentUser: {} || {};
    }},
  },
  data() {
    let $this = this;
    return {
      csrf: document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : '',
      user: this.$store ? this.$store.state.auth.currentUser: {} || {},
      recaptch_key: (window.Laravel ? window.Laravel.recaptch_key : ''),
      session: {old: (window.Laravel ? window.Laravel.old : {}) , errors: (window.Laravel ? window.Laravel.errors : {})},

      app_name: appConfig.title,
      website_id: appConfig.website_id,
      app_url: appConfig.app_url,
      storage_url: appConfig.app_url+'/storage',
      app_admin_url: appConfig.app_admin_url,
      app_email: appConfig.email,
      app_phone: appConfig.phone,
      app_address: appConfig.address,
      app_city: appConfig.city,
      app_state: appConfig.state,
      app_zip_code: appConfig.zip_code,
      app_latitude: appConfig.latitude,
      app_longitude: appConfig.longitude,
      app_description: appConfig.description,

      google_key: appConfig.google_key,
      app_website_ids: (appConfig.website_ids ? appConfig.website_ids.split(',') : []),

      isAdmin: false,

      widgets: widgets,
      theme_colors: [
        {name:"revinre",value:"revinre"},
        {name:"realty-express",value:"realty-express"},
        {name:"blue",value:"blue"},
        {name:"indigo",value:"indigo"},
        {name:"purple",value:"purple"},
        {name:"pink",value:"pink"},
        {name:"red",value:"red"},
        {name:"orange",value:"orange"},
        {name:"yellow",value:"yellow"},
        {name:"green",value:"green"},
        {name:"teal",value:"teal"},
        {name:"cyan",value:"cyan"},
        {name:"primary",value:"primary"},
        {name:"secondary",value:"secondary"},
        {name:"warning",value:"warning"},
        {name:"success",value:"success"},
        {name:"lighten-success",value:"lighten-success"},
        {name:"darken-success",value:"darken-success"},
        {name:"info",value:"info"},
        {name:"danger",value:"danger"},
        {name:"white",value:"white"},
        {name:"black",value:"black"},
        {name:"light",value:"light"},
        {name:"dark",value:"dark"},
        {name:"muted",value:"muted"},
        {name:"gray-100",value:"gray-100"},
        {name:"gray-200",value:"gray-200"},
        {name:"gray-300",value:"gray-300"},
        {name:"gray-400",value:"gray-400"},
        {name:"gray-500",value:"gray-500"},
        {name:"gray-600",value:"gray-600"},
        {name:"gray-700",value:"gray-700"},
        {name:"gray-800",value:"gray-800"},
        {name:"gray-900",value:"gray-900"},
      ],
    }
  },
  created() {
    document.domain = window.location.hostname.replace("admin.", "");
    if(window.location.origin+'/' == this.app_admin_url) { this.isAdmin = true; } else { this.isAdmin = false; }
  },
  methods: {
    popupErrors(res) {
      if(res.response) { console.log(res.response); } else { console.log(res); }
      if(res.response && res.response.data && res.response.data.errors) {
        for(var i in res.response.data.errors) {
          if(res.response.data.errors[i] != null && res.response.data.errors[i].length > 0){ this.$noty.error(res.response.data.errors[i]); }
        }
      } else if(res.response && res.response.data && res.response.data.message) {
        this.$noty.error(res.response.data.message);
      } else {
        this.$noty.error('Unknown error has occurred');
      }
    },
    hasRole(role) {
      var result = false;
      if(role.constructor === Array) {
        role.forEach(function(entry) {
          if(store && store.state && store.state.auth && store.state.auth.currentUser) {
            Object.entries(store.state.auth.currentUser.roles).forEach(([key, val]) => {
              if(val.title == entry) { result = true; }
            });
          }
        });
      } else {
        if(store && store.state && store.state.auth && store.state.auth.currentUser) {
          Object.entries(store.state.auth.currentUser.roles).forEach(([key, val]) => {
            if(val.title == role) { result = true; }
          });
        }
      }
      return result;
    },
    formatPhone(item) {
      var cleaned = ('' + item).replace(/\D/g, '');
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if(match) { var intlCode = (match[1] ? '+1 ' : ''); return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');}
      return null
    },
    formatPrice(value, previx=true, decimal=true) {
      let val = +value === +value ? +value : 0;
      var out = (decimal ? val.toLocaleString('en-US', {style:'currency',currency:'USD'}) : val.toLocaleString('en-US', {style:'currency',currency:'USD',minimumFractionDigits: 0}));
      return (!previx ? out.replace("$", "") : out);
    },
    formatImage(url) {
      if(!url || url.startsWith('http')) { return this.fullurlencode(url); } else { return this.fullurlencode(this.storage_url+url); }
    },
    emailTimeDisplay(dbDate) {
      dbDate = new moment(dbDate);
      var currentDate = new moment();
      if (currentDate.isSame(dbDate, 'day'))
        return dbDate.format('h:mm a');
      else if (currentDate.isSame(dbDate, 'year'))
        return dbDate.format("MMM DD");
      else
        return dbDate.format("MM/DD/YYYY");
    },
    formatSize(bytes) {
      var thresh = 1024;
      if(!bytes) { return ''; }
      if(Math.abs(bytes) < thresh) { return bytes + ' B'; }
      var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
      var u = -1;
      do { bytes /= thresh; ++u; } while(Math.abs(bytes) >= thresh && u < units.length - 1);
      return bytes.toFixed(0)+' '+units[u];
    },
    gs(fn, defaultVal="") {
      try { if(fn()) { return fn(); } else { return defaultVal; } } catch (e) { return defaultVal; }
    },
    eurl(url){
      return encodeURI(url).replace('(', '%28').replace(')', '%29');
    },
    fullurlencode(url = '') {
      var parser = document.createElement('a');
      parser.href = url;
      var scheme = parser.protocol;
      var host = parser.host;
      var path = parser.pathname;
      var query = parser.search;
      var output = "";
      if(scheme && host) { output += scheme+'//'+host; }
      if(path) { path = path.replace(/^\/+|\/+$/g, '').split("/"); for(var i in path) { output += '/'+encodeURIComponent(decodeURIComponent(path[i])); } }
      // PHP if(!empty($query)) { $query = explode('/', $query); foreach($path as $k=>$v) { $return .= '/'.rawurldecode($v); } }
      return output;
    },
    numOnly(e) {
      e = (e) ? e : window.event;
      var charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) { e.preventDefault(); } else { return true; }
    },
    setStickyNav() {
      if($('.sticky-header thead tr:first-of-type').length) {
        if(($('.sticky-header thead tr:first-of-type').offset().top - $(window).scrollTop()) < 70) {
          $('.sticky-header thead tr.sticky-thead').find('th, td').each(function(index) {
            var width = $('.sticky-header thead tr:first-of-type th, .sticky-header thead tr:first-of-type td').eq(index).outerWidth();
            $(this).css({width: width});
          });
          $('.sticky-header thead tr.sticky-thead').css({display: 'block', left: $('.sticky-header thead tr:first-of-type').offset().left, width: $('.sticky-header thead tr:first-of-type').outerWidth()});
        } else {
          $('.sticky-header thead tr.sticky-thead').css({display: 'none'});
        }
      }
    },
    changeTab(item) {
      window.location.hash = item;
    },
    copyClip(el) {
      window.getSelection().selectAllChildren(el);
      document.execCommand("Copy");
      this.$noty.success('Copied to clipboard');
      // var myTemporaryInputElement = document.createElement("input");
      // myTemporaryInputElement.type = "text";
      // myTemporaryInputElement.value = el[0].innerText;
      // document.body.appendChild(myTemporaryInputElement);
      // myTemporaryInputElement.select();
      // document.execCommand("Copy");
      // document.body.removeChild(myTemporaryInputElement);
      // this.$noty.success('Copied to clipboard');
      // window.getSelection().selectAllChildren(el[0]);
    },
    clearDates(dates) {
      for(var i in dates) { try { this.$refs[dates[i]].clearDate(); } catch(err) { } }
    },
  }
})


const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
